import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useApiClient } from '@/context/ApiClientContext/useApiClient.ts';
import useAutomationId from '@/hooks/useAutomationId.ts';
import useRunId from '@/hooks/useRunId.ts';
import { StepRunConnections } from '@/types/stepExecutions.ts';
import { STEP_RUN_CONNECTIONS_KEY } from '@/utils/queryKeys.ts';
import { get_step_run_connections_url } from '@/utils/urls.ts';

const useRetrieveStepRunConnections = (
  stepRunId?: string,
  enabled = true,
): UseQueryResult<StepRunConnections, AxiosError> => {
  const apiClient = useApiClient();
  const automationId = useAutomationId();
  const runId = useRunId();

  return useQuery({
    queryKey: STEP_RUN_CONNECTIONS_KEY(automationId, runId, stepRunId),
    queryFn: async () => {
      const response = await apiClient.get<StepRunConnections>(
        get_step_run_connections_url(stepRunId),
      );
      return response.data;
    },
    enabled: !!stepRunId && enabled,
  });
};

export default useRetrieveStepRunConnections;
